import { render, staticRenderFns } from "./modalAgregarProductos.vue?vue&type=template&id=3fc39b4b&scoped=true&"
import script from "./modalAgregarProductos.vue?vue&type=script&lang=js&"
export * from "./modalAgregarProductos.vue?vue&type=script&lang=js&"
import style0 from "./modalAgregarProductos.vue?vue&type=style&index=0&id=3fc39b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc39b4b",
  null
  
)

export default component.exports